import { Center, Skeleton } from '@chakra-ui/react';
import GenericDataTableBtn from '@Modules/core/components/table/GenericDataTableBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TListOfSuspectTransactionDataTableData = {
  primaryKey: string | number,
  date: string,
  referenceNumber: string,
  cardNumber: string,
  trader: string,
  mcc: string,
  country: string,
  amount: string,
  currency: string,
  autorizationNumber: string,
  tc: string,
};

type Props = {
  isLoading: boolean | undefined,
  handleBtn: (row: any) => void,
};

const columnHelper = createColumnHelper<TListOfSuspectTransactionDataTableData>();

export function getListOfSuspectTransactionDataTableColumns({ isLoading, handleBtn }: Props) {
  return [
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('referenceNumber', {
      id: 'referenceNumber',
      header: 'Num. Référence',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'Num. Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('trader', {
      id: 'trader',
      header: 'Commerçant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('mcc', {
      id: 'mcc',
      header: 'Mcc',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('country', {
      id: 'country',
      header: 'Pays',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('amount', {
      id: 'amount',
      header: 'Montant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('currency', {
      id: 'currency',
      header: 'Devise',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('autorizationNumber', {
      id: 'autorizationNumber',
      header: 'N° Aut.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('tc', {
      id: 'tc',
      header: 'Tc',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <GenericDataTableBtn label='Règles' onClick={() => handleBtn(props.row)} />
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
